// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

export enum ElevatorUsage {
  Up = 0,
  Down = 1,
  Forward = 2,
  Backward = 3,
  Parked = 4,
  NormalStopped = 5,
  FaultedStopped = 6,
  AboveDoorZone = 7,
  InDoorZone = 8,
  BelowDoorZone = 9,
  FrontDoorOpening = 10,
  FrontDoorClosing = 11,
  RearDoorOpening = 12,
  RearDoorClosing = 13,
  FrontDoorOpened = 14,
  FrontDoorClosed = 15,
  RearDoorOpened = 16,
  RearDoorClosed = 17,
  FrontDoorStalled = 18,
  RearDoorStalled = 19,
  Moving = 20,
  Levelling = 21,
  RunUp = 22,
  RunDown = 23
}
